<template>
  <b-modal
    ref="modal"
    centered
    class="accept-rent-form modal-confirmation text-center p-3"
    hide-footer
    static
    @shown="onShow"
    @hidden="onShow"
  >
    <b-img
      slot="modal-header-close"
      :src="require('@/assets/icons/x-b.svg')"
      width="45"
      height="30"
    ></b-img>

    <div
      v-if="notification"
      class="d-flex flex-column justify-content-between align-items-center text-center"
    >
      <b-img
        :src="require('@/assets/images/alert-success.svg')"
        width="150"
        height="150"
        class="modal-confirmation__icon"
      ></b-img>

      <h2>Accept request</h2>

      <b-card>
        <div class="rent-detail d-flex flex-row">
          <b-avatar :src="avatar" size="60px" class="mr-4"></b-avatar>
          <div class="d-flex flex-column justify-content-center">
            <div class="text-left">
              <h5>{{ notification.message }}</h5>
              <p>{{ tool.name }}</p>
            </div>
            <div class="notification-date d-flex flex-row align-items-center">
              <b-img
                width="15"
                class="notification-icon"
                :src="require('@/assets/icons/calendar.svg')"
              ></b-img>
              <label>{{ from }}</label>
              <b-img
                width="15"
                class="notification-icon"
                :src="require('@/assets/icons/arrow-right-tail-b.svg')"
              ></b-img>
              <label>{{ to }}</label>
            </div>
          </div>
        </div>
      </b-card>

      <p class="my-4">
        Are you sure you want to accept the request?
      </p>
      <div class="modal-confirmation__footer">
        <b-button variant="outline-secondary" @click="close()">Cancel</b-button>
        <b-button
          variant="primary"
          :disabled="form.$busy"
          @click="onConfirmation"
        >
          <b-spinner small v-if="form.$busy"></b-spinner>&nbsp;Accept
        </b-button>
      </div>
    </div>
  </b-modal>
</template>
<script>
/**
 * ==================================================================================
 * Accept rent request form
 * ==================================================================================
 **/

import { mapActions } from 'vuex'
import Form from '@/utils/form'
import Notification from '@/models/Notification'

export default {
  props: {
    notification: {
      type: [Notification, Object]
    }
  },
  computed: {
    actor() {
      return this.notification && this.notification.actor
        ? this.notification.actor
        : null
    },

    avatar() {
      if (!this.actor) return
      return (
        this.actor.avatar_permanent_thumb_url || this.actor.avatar_permanent_url
      )
    },

    tool() {
      return this.rent && this.rent.tool ? this.rent.tool : {}
    },

    rent() {
      return this.notification && this.notification.rent_request
        ? this.notification.rent_request
        : {}
    },

    from() {
      if (!this.rent) return 'NA'
      return this.parseDate(this.rent.from, 'DD/MM/YYYY')
    },
    to() {
      if (!this.rent) return 'NA'
      return this.parseDate(this.rent.to, 'DD/MM/YYYY')
    }
  },
  data: function() {
    return {
      form: new Form({})
    }
  },
  methods: {
    ...mapActions({
      acceptRequest: 'notification/acceptRequest',
      addAlert: 'alert/addAlert'
    }),
    async onConfirmation() {
      if (this.form.$busy) return
      this.form.$setLoading(true)
      this.addAlert({
        state: true,
        label: 'Accepting rent request...',
        countdown: true
      })

      await this.acceptRequest({
        id: this.rent.renter_code
      })
        .then(data => {
          this.form.$setLoading(false)
          this.addAlert({
            label: 'Request has been accepted'
          })

          this.close()
          this.$emit('accepted', data.data.data)
        })
        .catch(error => {
          this.form.$setLoading(false)
          this.form.$handleError(error)
          this.addAlert({
            state: false,
            label: this.form.$errorMessage
          })

          /**
           * If Stripe payment method of the renter fails
           * in any way catch the decline notification
           */
          if (
            error.response &&
            error.response.status === 400 &&
            error.response.data &&
            error.response.data.errors &&
            error.response.data.errors.data
          ) {
            this.$emit('accepted', error.response.data.errors.data)
          }

          this.close()
        })
    },

    onShow() {
      this.form.$errorMessage = ''
    },

    show() {
      this.$refs.modal.show()
    },

    close() {
      this.$refs.modal.hide()
    }
  }
}
</script>
<style lang="scss" scoped>
.accept-rent-form {
  h2 {
    margin-bottom: 40px;
  }

  .modal-confirmation__icon {
    margin: 0 auto;
  }

  .card {
    border: 1px solid #ededed;
    box-shadow: 0px 6px 12px #00000008;
    margin-bottom: 20px;

    .card-body {
      padding: 1rem 1.75rem;
    }

    .notification-date {
      margin-top: 2.5px;

      label {
        margin-bottom: 0;
      }

      > * {
        margin-right: 10px;
      }
    }

    .rent-detail {
      h5,
      p {
        margin-bottom: 0;
      }

      h5 {
        font-weight: 600;
      }
    }
  }
}
</style>
